export default {
  url: process.env.REACT_APP_SOCKET_URL,
};
